import React from 'react';
import styled, { css } from 'styled-components';
import Text from '../../ui/Text';
import ArrowWhite from '../../images/arrow_left_white.svg';
import { connect } from 'react-redux';
import { browserHistoryGoBack } from '../../utils/UiHelper';
import Icon from '../../ecoui/Icon';

const BackButtonWrapper = styled.button`
    height: auto;
    width: auto;
    min-width: 50px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 2px;
    padding: 8px 16px 8px 12px;
    background: ${({ isMobile }) => (isMobile ? 'transparent' : '#2E4D6D')};
    border-radius: 5px;
    border: none;
    outline: none;
    position: fixed;
    top: 68px;
    left: 90px;
    z-index: ${({ isMobile }) => (isMobile ? '10' : '5')};
    transition: all 0.1s ease-in-out;
    &.open {
        left: 280px;
    }
    &:hover {
        cursor: pointer;
    }
    img {
        display: inline-block;
        box-sizing: border-box;
    }
    p {
        width: auto;
    }

    ${({ isMobile }) =>
        isMobile &&
        css`
            left: 0;
            padding: 8px 15px 8px 10px;

            @media screen and (max-width: 700px) {
                top: 86px;
            }
        `};
`;

const BackButton = ({
    isLeftSideBarOpen,
    eventTitle,
    onClickBackBtn,
    isMobile,
}) => {
    return (
        <BackButtonWrapper
            onClick={onClickBackBtn ? onClickBackBtn : browserHistoryGoBack}
            className={`${isLeftSideBarOpen ? 'open' : ''} `}
            isMobile={isMobile}
        >
            <Icon
                src={ArrowWhite}
                width={isMobile ? '32px' : '24px'}
                height={isMobile ? '32px' : '24px'}
                color="#fff"
            />
            {!isMobile && (
                <Text
                    color={'#fff'}
                    center
                    size="12"
                    lh="24"
                    bold
                    padding="0"
                    margin={'0'}
                >
                    {eventTitle}
                </Text>
            )}
        </BackButtonWrapper>
    );
};

function mapStateToProps(state) {
    return {
        isLeftSideBarOpen: state.ui.leftSidebarOpen,
    };
}

export default connect(
    mapStateToProps,
    null
)(BackButton);
